module.exports = __webpack_public_path__ + "img/DealerIcons-M1Build-On.4ec2b99.jpg";